import { render, staticRenderFns } from "./YzMenu.vue?vue&type=template&id=a77cac74&lang=pug&"
import script from "./YzMenu.vue?vue&type=script&lang=js&"
export * from "./YzMenu.vue?vue&type=script&lang=js&"
import style0 from "./YzMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
